import RequisitionsLinesModal from '../../../../components/Corporate/Requisitions/Lines/RequisitionsLinesModal'
import List from '../../../../components/Corporate/Requisitions/Lines/List'
import React, { Fragment } from 'react'

function RequisitionsLines (props) {
  const { requisition } = props
  return (
    <Fragment>
      <RequisitionsLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default RequisitionsLines
